import store from "../stateManagement/store";

// Helper function to get the model from the store
export async function getModel(modelName: string) {
  const model = store.getState().serviceRegistry.get("Database").model(modelName);
  return model;
}

export async function dropAllMasterTables() {
  const jsonRegistry = require("../mergedSchema.json");
  const dbService = store.getState().serviceRegistry.get("Database");

  const entries = Object.entries(jsonRegistry.schemas) as [string, { _meta?: { type?: string } }][];

  for (const [key, schema] of entries) {
    if (schema['_meta'] && schema['_meta']['type']?.toUpperCase() === "MASTERDATA") {
      await dbService.model(key).clear();
    }
  }
}

// Clears all data from the specified local database model
export async function clearAllDataFromLocalDb(modelName: string): Promise<void> {
  try {
    const model = await getModel(modelName);
    await model.clear();
  } catch (err) {
    throw new Error(`Error clearing all records from the ${modelName}`);
  }
}

// Appends new data to the specified local database model
export async function insertDataIntoLocalDB(modelName: string, data: any): Promise<void> {
  try {
    const model = await getModel(modelName);
    await model.saveAll(data);
  } catch (err) {
    console.log(err);
    throw new Error(`Error saving the ${modelName} data`);
  }
}

// Fetches records from the specified local database model based on a query with pagination
export async function getDataFromLocalDb(
  modelName: string,
  query: any = {},
  page?: number,
  limit?: number,
  sortRecommendationFilter?: boolean
): Promise<{ data: any; total: number }> {
  try {
    const model = await getModel(modelName);
    let collection = await model.find(query);
    let data = await collection?.data;

    // Custom sorting logic for recommendationPriority
    if (sortRecommendationFilter) {
      data?.sort((a: any, b: any) => {
          const priorityOrder = [2, 1, 0]; // Define the desired order
          const indexA = priorityOrder.includes(a.recommendationPriority) 
              ? priorityOrder.indexOf(a.recommendationPriority) 
              : priorityOrder.length;
          const indexB = priorityOrder.includes(b.recommendationPriority) 
              ? priorityOrder.indexOf(b.recommendationPriority) 
              : priorityOrder.length;
          
          return indexA - indexB;
      });
    }

    if (page !== undefined && limit !== undefined) {
      const skip = (page - 1) * limit;
      const paginatedData = data.slice(skip, skip + limit);
      return { data: paginatedData, total: data.length };
    } else {
      return { data, total: data.length };
    }
  } catch (err) {
    console.error(err);
    throw new Error(`Error fetching data from the ${modelName}`);
  }
}
